module.exports = __webpack_public_path__ + "img/banner.686a4108.png";